export const NOTIFICATIONS_STATUSES = {
  READ: '2_READ',
};

export const UnreadNotificationStatusPrefix = '1_';
